import React, { useState } from 'react';

import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';

import { useQuery } from 'react-query';

import ISTable from 'components/lSTable';
import useToken from 'hooks/useToken';
import PrivateLayout from 'layouts/private';
import TableButtonsContainer from 'components/TableButtonsContainer';
import { fetchCapital } from 'apiRequest/capitals';
import { fetchCapitalEntries } from 'apiRequest/capital-entries';
import dateTime from 'utils/datetime';
import currency from 'utils/currency';

export default function CapitalEntryList() {
  const { id } = useParams();

  const { token } = useToken();

  const { data: capital, isLoading, isError, error } = useQuery("capital-fetchCapital", () => {
    return fetchCapital({
      token,
      id,
      params: {
        partials: [
          'account',
        ]
      }
    });
  });


  const { data: capitalEntries, isLoading: capitalEntriesIsLoading, isError: capitalEntriesIsError, error: capitalEntriesError } = useQuery("capitalEntry-fetchCapitalEntries", () => {
    return fetchCapitalEntries({
      token, id, params: {
        filters: {
          'capital_id': id,
        }
      }
    });
  });


  const [params, setParams] = useState({
    partials: ['account', 'figure'],
    sort_by: {
      "key": "id",
      "order": "desc"
    }
  });


  const handlePageChange = (page) => {
    setParams({ ...params, page });
  };

  const capitalEntriesTypes = React.useMemo(() => {
    return {
        'loan': 'Loan (shop<-customer)',
        'repay': 'Repay (shop->customer)',
        'advance': 'Advance (shop->customer)',
        'collect': 'Collect (shop<-customer)',
        'deposit': 'Deposit (shop+)',
        'withdraw': 'Withdraw (shop-)',
      }
  });

  console.log('capitalEntriesTypes', capitalEntriesTypes['loan']);

  const columns = React.useMemo(() => [
    {
      key: 'id',
      label: 'ID',
      selector: row => row.id,
    },
    {
      key: 'quantity',
      label: 'Quantity',
      highlight: true,
      selector: row => row.quantity,
    },
    {
      key: 'amount',
      label: 'Amount',
      currency: true,
      highlight: true,
      selector: row => row.quantity * capital?.data.data.figure.worth,
    },
    {
      key: 'type',
      label: 'Type',
      selector: row => capitalEntriesTypes[row.type] || row.type,
    },
    {
      key: 'note',
      label: 'Note',
      selector: row => row.note,
    },
    {
      key: 'created_at',
      label: 'Date',
      selector: row => dateTime.format(row.created_at),
    },
  ], [capital]);

  return (
    <PrivateLayout loading={isLoading} isError={isError} error={error}>
      <TableButtonsContainer>
        <Button
          variant="contained"
          component={RouterLink}
          to={`/capitals/${id}/entries/create`}
        >
          Add New Capital Entry
        </Button>
      </TableButtonsContainer>
      <ISTable
        title={`Capital Entries of ID: ${id}`}
        subheader={`Account: ${capital?.data.data.account.name} | crrency: ${capital?.data.data.figure.code}`}
        maxWidth="lg"
        size='small'
        loading={capitalEntriesIsLoading}
        columns={columns}
        data={capitalEntries?.data.data}
        pagination
        count={capitalEntries?.data.total}
        page={capitalEntries?.data.current_page}
        rowsPerPage={capitalEntries?.data.per_page}
        onPageChange={handlePageChange}
        TableLeftFooter={TableLeftFooter}
        tableLeftFooterProps={{ capital: capital?.data?.data }}
      />
    </PrivateLayout>
  );
}

const TableLeftFooter = ({ capital }) => {
  return (
    <Box>
      <Typography variant="h6">Total Amount</Typography>
      {capital && (
        <>
          <Box display='flex'>
            <Typography variant="body1" width='70px' fontWeight='bold'>Quantity:</Typography>
            <Typography variant="body1">{capital.quantity}</Typography>
          </Box>
          <Box display='flex'>
            <Typography variant="body1" width='70px' fontWeight='bold'>Amount:</Typography>
            <Typography variant="body1">{currency.format(capital.amount, 2)}</Typography>
          </Box>
        </>
      )}
    </Box>
  );
};
